import styled from 'styled-components'

import { mainColors } from '../../styles/colors'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const Root = styled.div<{ editable?: boolean; isEditing?: boolean }>`
  display: flex;
  border-radius: 4px;
  padding: 2px 4px 2px 8px;
  align-items: center;
  gap: 4px;
  outline: none;
  border: 1px solid transparent;
  margin: -2px -2px -2px -8px;
  min-height: 28px;

  > svg {
    cursor: pointer;
  }

  .pencil {
    display: none;
    color: ${mainColors.accentMedium};
  }

  ${({ editable, isEditing }) =>
    editable && !isEditing
      ? `
  &:hover  {
    border: 1px solid ${mainColors.accentDark};
    background: ${mainColors.accentExtremelyLight};

    .pencil {
      display: block;
    }
  }
  `
      : ''}

  ${({ isEditing }) =>
    isEditing
      ? `
    border: 1px solid ${mainColors.accentDark};
    background: ${mainColors.neutralMedium};

    .pencil {
      display: none;
    }
  }
  `
      : ''}
`

export const EditableContent = styled.div`
  display: flex;
  border: 0;
  outline: 0;
`

export const Input = styled.input`
  border: 0;
  background: transparent;
  outline: 0;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  width: auto;
  max-width: max-content;
`
